import * as React from "react";
import { cn } from "@/lib/utils";

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

function Label({ className, ...props }: LabelProps) {
  return <label className={cn("text-white/80 text-sm font-medium", className)} {...props} />;
}

export { Label };
